import React from 'react'
import PropTypes from 'prop-types'
import Form from '../../../2_Molecules/Form/Form'
import { useForm } from '../../../../hooks/useForm'
import { languageController } from '../../../../controllers/language/languageController'
import Button from '../../../1_Atoms/Button/Button'
import { Svg } from '../../../1_Atoms/Svg/Svg'
import Textarea from '../../../1_Atoms/Forms/Textarea/Textarea'
import Checkbox from '../../../1_Atoms/Forms/Checkbox/Checkbox'
import formLang from '../../../../controllers/language/shared/form'

function ServiceDetailsStep_BaSA({
  handleNextStep,
  language,
}) {
  const initState = {
    message: '',
    services: [],
  }

  const { handleSubmit, handleChange, data, setData } = useForm({
    initState,
    onSubmit: () => {
      try {
        if (!services.length > 0) return;

        // Convert services arr to 'XXXX,XXXXX' format.
        const servicesStringList =
          services.map(serviceKey => servicesListObj[serviceKey][language].toUpperCase()).join(',');

        handleNextStep({
          serviceDetails: { message: message, services: servicesStringList }
        })
      } catch (err) {
        console.log('Error: ', err)
      }
    },
  })

  const { message, services } = data;

  const servicesListObj = formLang.checkboxes.services;

  return (
    <div className="mz-service-details-step-basa">
      <div className="mz-container">
        <div className="grid-inner-content">
          <div className="mz-service-details-step-basa__top">
            <h5 className="mz-service-details-step-basa__title">{languageController.getCopy('bookServiceAppointment', 'step2Title')}</h5>
            {/* TODO: Needs to display the chosen vehicle name at the end? */}
            <p className="mz-service-details-step-basa__sub-title">{languageController.getCopy('bookServiceAppointment', 'step2SubTitle')}</p>
          </div>
          <Form
            onSubmit={handleSubmit}
            isDark={false}
            noValidate={true}
          >
            <div className="mz-service-details-step-basa__services">
              {
                Object.keys(servicesListObj).map(key => {
                  const label = servicesListObj[key][language];
                  return (
                    <Checkbox
                      key={key}
                      label={label}
                      name={key}
                      value={label}
                      checked={services.includes(key)}
                      onChange={(e) => {
                        // If currently checked, remove it from the list.
                        if (services.includes(key)) {
                          setData({
                            ...data,
                            services: services.filter(service => service !== key)
                          })
                        } else {
                          setData({
                            ...data,
                            services: [...services, key]
                          })
                        }
                      }}
                    />
                  )
                })
              }
            </div>
            <Textarea
              name="message"
              label={languageController.getFormCopy('label', 'additionalInfo')}
              value={message}
              onChange={handleChange}
              maxLength={2500}
              rows={5}
            />
            <Button
              type="submit"
              className="mz-btn--primary mz-btn--red"
              label={languageController.getCopy('global', 'continue')}
              buttonIcon={<Svg type="chevron_small" size={0.8} colour="white" style={{ top: '1px' }} />}
              buttonIconPosition="right"
              disabled={(!services.length > 0)}
            />
          </Form>
        </div>
      </div>
    </div>
  )
}

ServiceDetailsStep_BaSA.propTypes = {
  handleNextStep: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
}

export default ServiceDetailsStep_BaSA

